/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Preferences_TitleInputs */

const en_cookies_preferences_title = /** @type {(inputs: Cookies_Preferences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie preferences`)
};

const pl_cookies_preferences_title = /** @type {(inputs: Cookies_Preferences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia plików cookie`)
};

/**
* | output |
* | --- |
* | "Cookie preferences" |
*
* @param {Cookies_Preferences_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_preferences_title = /** @type {((inputs?: Cookies_Preferences_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Preferences_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_preferences_title(inputs)
	return en_cookies_preferences_title(inputs)
});